import { render, staticRenderFns } from "./VirtualOrgEdit.vue?vue&type=template&id=cca16ad2"
import script from "./VirtualOrgEdit.vue?vue&type=script&lang=js"
export * from "./VirtualOrgEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports